/* unplugin-vue-components disabled */import script from "./cooperative-partner.vue?vue&type=script&setup=true&lang=ts"
export * from "./cooperative-partner.vue?vue&type=script&setup=true&lang=ts"

import "./cooperative-partner.vue?vue&type=style&index=0&id=4d882b72&lang=scss"

const __exports__ = script;

export default __exports__